import { createSelector } from 'reselect';

export const selectSafetyQuestionsSlice = state => state.safetyQuestions;

export const selectSafetyQuestions = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.safetyQuestions
);
export const safetyQuestionsLoaded = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.safetyQuestionsLoaded
);
export const selectActiveSafetyQuestion = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.activeSafetyQuestion
);

export const safetyQuestionsMeta = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.meta
);
export const safetyQuestionsFilters = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.filters
);
export const safetyQuestionsEvent = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.eventId
);

export const safetyQuestionCreating = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.isCreating
);
export const safetyQuestionUpdating = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.isUpdating
);
export const safetyQuestionDeleting = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.isDeleting
);
export const safetyQuestionsErrors = createSelector(
  selectSafetyQuestionsSlice,
  slice => slice.errors
);
